import { Pipe, PipeTransform } from '@angular/core';
import { FparIssueGroup, FparTableIssue } from '@core/models';

@Pipe({
  name: 'issuesNotOnHold',
  standalone: false,
})
export class IssuesNotOnHoldPipe implements PipeTransform {
  transform(issues: FparTableIssue[] | FparIssueGroup[]): FparTableIssue[] {
    // Check if issues is an array and the first element is a FparTableIssue (has 'onHold' property)
    if (
      !Array.isArray(issues) ||
      issues.length === 0 ||
      !('onHold' in issues[0])
    ) {
      // If it's FparIssueGroup[] or invalid, abort (return empty array)
      return [];
    }
    // Proceed if it's FparTableIssue[]
    return (issues as FparTableIssue[]).filter(
      (issue) => !issue.onHold && !issue.resolved,
    );
  }
}
